import { Store } from '@betgames/bg-state-manager';

export const selectedChipStore = new Store<number>({
    key: 'SelectedChip',
    persist: true,
    default: null,
});
